import { useState } from 'react';
import { nextUsableIndex } from 'src/utils/nextUsableIndex';

// Tracks media indices whose image failed to load and skips past them.
export const useBrokenMedia = (index, setIndex) => {
  const [broken, setBroken] = useState(new Set());

  const markBroken = i => setBroken(prev => new Set(prev).add(i));

  // Mark the current index broken and jump to the next usable one within `count`.
  const skipBroken = count => {
    markBroken(index);
    setIndex(nextUsableIndex(index, count, new Set(broken).add(index)));
  };

  return { broken, markBroken, skipBroken };
};
